

import { Pagination, Stack, TableBody, TableCell, TableHead, TableRow } from "@mui/material"
import { LayoutTabla } from "../../layout"
import { AlertScreen } from "../components/AlertScreen"
import { useOrdenesPagoStore } from "../../../store"
import { useNavigate } from "react-router-dom"

import dayjs from 'dayjs';



// selected, handleSelectAllClick, handleClick, isSelected, 
export const TablaOrdenCompras = ({ data, chagePage=null, page=0 }) => {


    const navigate = useNavigate();
    const { totalOrdenesPago } = useOrdenesPagoStore();


    const handleClick = (id) => {
        navigate(`/admin/ordencompra/${id}/detalles`)
    }


    return (
        <>
        {(data.length > 0)
        ?   <LayoutTabla
                paginado={
                    <Stack sx={{ py:2, display:'flex', justifyContent:'center', alignItems:'center' }}>
                        <Pagination count={Math.ceil(totalOrdenesPago / 50)} disabled={Math.ceil(totalOrdenesPago / 50) === 1}
                            variant="outlined" page={page + 1} color="primary" 
                            onChange={ (_, newValor) => chagePage(newValor) } 
                        />
                    </Stack>
            }>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{width:'15%'}}>Fecha</TableCell>
                        <TableCell sx={{width:'25%'}}>Numero</TableCell>
                        <TableCell sx={{width:'20%'}}>Items</TableCell>
                        <TableCell sx={{width:'20%'}}>Estado</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map( (d) => (
                        <TableRow key={d._id} sx={{padding:0, cursor:'pointer'}} onClick={ (_) => handleClick(d._id) }> 
                            <TableCell>{ dayjs(d.createdAt).format('DD/MM/YYYY') }</TableCell>
                            <TableCell>{ d.numero }</TableCell>
                            <TableCell>{ d.items.length }</TableCell>
                            <TableCell>{ d.estado }</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </LayoutTabla>

        : <AlertScreen title="No hay ordenes de compra por el momento..." />
        }
        </>
    )
}
